import {Tourn} from './inline/main';

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
    window.Tourn = Tourn;
} catch (e) {}
